export default __webpack_public_path__ + "static/SIM-physical-mandate-7423dcb091914c2f7ca0c0dd554da8e0.pdf";